module.exports = __webpack_public_path__ + "img/9788989675853.913c4cb1.jpg";